import {
  GET_DEMOGRAPHICS_REQUEST,
  GET_DEMOGRAPHICS_SUCCESS,
  GET_DEMOGRAPHICS_FAILURE,
  GET_DEMOGRAPHICS_SEARCH_RESULTS_FAILURE,
  GET_DEMOGRAPHICS_SEARCH_RESULTS_SUCCESS,
  GET_DEMOGRAPHICS_SEARCH_RESULTS_REQUEST,
  CHANGE_DATA_SOURCE_REQUEST,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
    loaded: false,
    demographicsSearchKeyResults: {},
    demographicsSearchKeyLoading: {},
  };
};

const initialState = getInitialState();

const demographicsItems = (state = initialState, action) => {
  const types = {
    [GET_DEMOGRAPHICS_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_DEMOGRAPHICS_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
      loaded: true,
    }),
    [GET_DEMOGRAPHICS_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
    [GET_DEMOGRAPHICS_SEARCH_RESULTS_REQUEST]: () => ({
      ...state,
      demographicsSearchKeyLoading: {
        [action.categoryId]: true,
      },
    }),
    [GET_DEMOGRAPHICS_SEARCH_RESULTS_SUCCESS]: () => ({
      ...state,
      demographicsSearchKeyResults: {
        ...state.demographicsSearchKeyResults,
        [action.demographicKey]: action.response,
      },
      demographicsSearchKeyLoading: {
        [action.demographicKey]: false,
      },
    }),
    [GET_DEMOGRAPHICS_SEARCH_RESULTS_FAILURE]: () => ({
      ...state,
      demographicsSearchKeyLoading: {
        [action.demographicKey]: false,
      },
    }),
    [CHANGE_DATA_SOURCE_REQUEST]: () => ({
      ...state,
      isLoading: false,
      error: false,
      loaded: false,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default demographicsItems;
